<h1 mat-dialog-title>{{_data.title}}</h1>
<div mat-dialog-content>
    <p>{{_data.msg}}</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Confirmar</button>
</div>